import { CollectionReference, db, DocumentReference } from "api/firebase";
import Order from "ts/api/order";

export type OrderDocRef = DocumentReference<Order>;
export type OrderCollectionRef = CollectionReference<Order>;

type GetDocumentArgs = {
  showId: string;
  orderId: string;
};

type GetCollectionArgs = Omit<GetDocumentArgs, "orderId">;

const orderRefs = {
  getDocument: ({ showId, orderId }: GetDocumentArgs) =>
    db
      .collection("shows")
      .doc(showId)
      .collection("orders")
      .doc(orderId) as OrderDocRef,
  getCollection: ({ showId }: GetCollectionArgs) =>
    db
      .collection("shows")
      .doc(showId)
      .collection("orders") as OrderCollectionRef,
};

export default orderRefs;
